import lozad from 'lozad'

export default class Lazy {
    constructor(element) {
        this.element = element;

        const observer = lozad(this.element, {
            loaded: (element) => {
                this.processAutoplay(element);
            }
        });
        observer.observe();
    }

    processAutoplay(element) {
        if(element.nodeName === "VIDEO" && element.getAttribute("data-autoplay") === "true") {
            this.initAutoplay(element);
        }
    }

    initAutoplay(video) {
        video.play();
        video.setAttribute("autoplay", "")
    }
}
